<template>
  <div :class="textClass">
    <slot name="label">
      <label v-if="hasLabel" class="rt-attr-label">{{ label }}</label>
    </slot>
    <slot>
      <span class="rt-attr-text">{{ text }}</span>
    </slot>
    <slot name="link">
      <div v-if="link" class="rt-attr-link">
        <a @click="link">{{ $tx('详情', 'xpc.business.attr.detail') }}</a>
        <rt-icon name="rt-base-arrow_right" />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'RtAttr',
  props: {
    type: {
      type: String,
      default: 'sub'
    },
    label: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    link: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textClass() {
      return ['rt-attr', `rt-attr-${this.type}`, { 'rt-light': this.light }];
    },
    hasLabel() {
      return !!this.label;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAttr.vue?cd865488